export const PointIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 22.7504C8 22.7504 4.75 19.8804 4.75 16.3504V12.6504C4.75 12.2404 5.09 11.9004 5.5 11.9004C5.91 11.9004 6.25 12.2404 6.25 12.6504C6.25 15.2704 8.72 17.2504 12 17.2504C15.28 17.2504 17.75 15.2704 17.75 12.6504C17.75 12.2404 18.09 11.9004 18.5 11.9004C18.91 11.9004 19.25 12.2404 19.25 12.6504V16.3504C19.25 19.8804 16 22.7504 12 22.7504ZM6.25 16.4604C6.32 19.1104 8.87 21.2504 12 21.2504C15.13 21.2504 17.68 19.1104 17.75 16.4604C16.45 17.8704 14.39 18.7504 12 18.7504C9.61 18.7504 7.56 17.8704 6.25 16.4604Z"
        fill="#FF5349"
      />
      <path
        d="M12 13.75C9.24 13.75 6.75999 12.51 5.54999 10.51C5.02999 9.66 4.75 8.67 4.75 7.65C4.75 5.93 5.52 4.31 6.91 3.09C8.27 1.9 10.08 1.25 12 1.25C13.92 1.25 15.72 1.9 17.09 3.08C18.48 4.31 19.25 5.93 19.25 7.65C19.25 8.67 18.97 9.65 18.45 10.51C17.24 12.51 14.76 13.75 12 13.75ZM12 2.75C10.44 2.75 8.98001 3.27 7.89001 4.23C6.83001 5.15 6.25 6.37 6.25 7.65C6.25 8.4 6.44999 9.1 6.82999 9.73C7.77999 11.29 9.76 12.25 12 12.25C14.24 12.25 16.22 11.28 17.17 9.73C17.56 9.1 17.75 8.4 17.75 7.65C17.75 6.37 17.17 5.15 16.1 4.21C15.01 3.27 13.56 2.75 12 2.75Z"
        fill="#FF5349"
      />
      <path
        d="M12 18.75C7.87 18.75 4.75 16.13 4.75 12.65V7.65C4.75 4.12 8 1.25 12 1.25C13.92 1.25 15.72 1.9 17.09 3.08C18.48 4.31 19.25 5.93 19.25 7.65V12.65C19.25 16.13 16.13 18.75 12 18.75ZM12 2.75C8.83 2.75 6.25 4.95 6.25 7.65V12.65C6.25 15.27 8.72 17.25 12 17.25C15.28 17.25 17.75 15.27 17.75 12.65V7.65C17.75 6.37 17.17 5.15 16.1 4.21C15.01 3.27 13.56 2.75 12 2.75Z"
        fill="#FF5349"
      />
    </svg>
  );
};

export const RewardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20 12V18C20 20.21 18.21 22 16 22H8C5.79 22 4 20.21 4 18V12C4 11.45 4.45 11 5 11H6.97C7.52 11 7.97 11.45 7.97 12V15.14C7.97 15.88 8.38 16.56 9.03 16.91C9.32 17.07 9.64 17.15 9.97 17.15C10.35 17.15 10.73 17.04 11.06 16.82L12.01 16.2L12.89 16.79C13.5 17.2 14.28 17.25 14.93 16.9C15.59 16.55 16 15.88 16 15.13V12C16 11.45 16.45 11 17 11H19C19.55 11 20 11.45 20 12Z"
        fill="#FF5349"
      />
      <path
        d="M21.5 7V8C21.5 9.1 20.97 10 19.5 10H4.5C2.97 10 2.5 9.1 2.5 8V7C2.5 5.9 2.97 5 4.5 5H19.5C20.97 5 21.5 5.9 21.5 7Z"
        fill="#FF5349"
      />
      <path
        d="M11.6408 5.00043H6.12076C5.78076 4.63043 5.79076 4.06043 6.15076 3.70043L7.57076 2.28043C7.94076 1.91043 8.55076 1.91043 8.92076 2.28043L11.6408 5.00043Z"
        fill="#FF5349"
      />
      <path
        d="M17.8696 5.00043H12.3496L15.0696 2.28043C15.4396 1.91043 16.0496 1.91043 16.4196 2.28043L17.8396 3.70043C18.1996 4.06043 18.2096 4.63043 17.8696 5.00043Z"
        fill="#FF5349"
      />
      <path
        d="M13.9695 11C14.5195 11 14.9695 11.45 14.9695 12V15.13C14.9695 15.93 14.0795 16.41 13.4195 15.96L12.5195 15.36C12.1895 15.14 11.7595 15.14 11.4195 15.36L10.4795 15.98C9.81945 16.42 8.93945 15.94 8.93945 15.15V12C8.93945 11.45 9.38945 11 9.93945 11H13.9695Z"
        fill="#FF5349"
      />
    </svg>
  );
};

export const CardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M22 7.55039C22 8.21039 21.46 8.75039 20.8 8.75039H3.2C2.54 8.75039 2 8.21039 2 7.55039V7.54039C2 5.25039 3.85 3.40039 6.14 3.40039H17.85C20.14 3.40039 22 5.26039 22 7.55039Z"
        fill="#FF5349"
      />
      <path
        d="M2 11.45V16.46C2 18.75 3.85 20.6 6.14 20.6H17.85C20.14 20.6 22 18.74 22 16.45V11.45C22 10.79 21.46 10.25 20.8 10.25H3.2C2.54 10.25 2 10.79 2 11.45ZM8 17.25H6C5.59 17.25 5.25 16.91 5.25 16.5C5.25 16.09 5.59 15.75 6 15.75H8C8.41 15.75 8.75 16.09 8.75 16.5C8.75 16.91 8.41 17.25 8 17.25ZM14.5 17.25H10.5C10.09 17.25 9.75 16.91 9.75 16.5C9.75 16.09 10.09 15.75 10.5 15.75H14.5C14.91 15.75 15.25 16.09 15.25 16.5C15.25 16.91 14.91 17.25 14.5 17.25Z"
        fill="#FF5349"
      />
    </svg>
  );
};

export const HandClickIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="77"
      height="77"
      viewBox="0 0 77 77"
      fill="none"
    >
      <g clip-path="url(#clip0_36_2)">
        <path
          d="M65.0222 37.6444C61.1722 33.5805 56.0389 30.8 50.6916 29.7305C48.3389 29.0889 45.9861 28.6611 43.6333 28.4472C49.6222 21.3889 48.5527 10.6944 41.4944 4.70554C34.4361 -1.28335 23.7416 -0.213901 17.7527 6.84443C11.7639 13.9028 12.8333 24.5972 19.8916 30.5861C21.175 31.6555 22.4583 32.5111 23.7416 32.9389V37.6444L20.3194 34.4361C17.325 31.4417 12.4055 31.4417 9.19719 34.4361C6.20275 37.4305 5.98886 42.1361 8.9833 45.1305L18.8222 56.6805C19.25 59.675 20.3194 62.4555 21.8166 65.0222C22.8861 66.9472 24.3833 68.8722 25.8805 70.3694V74.4333C25.8805 75.7167 26.7361 76.5722 28.0194 76.5722H57.1083C58.1777 76.5722 59.2472 75.5028 59.2472 74.4333V68.8722C63.3111 63.9528 65.45 57.75 65.45 51.5472V39.1417C65.6639 38.2861 65.45 37.8583 65.0222 37.6444ZM17.9666 17.5389C17.9666 10.4805 23.7416 4.91943 30.8 5.13332C37.8583 5.13332 43.4194 10.9083 43.2055 17.9667C43.2055 21.8167 41.4944 25.2389 38.5 27.5917V16.8972C38.3907 15.0436 37.5766 13.302 36.2245 12.0293C34.8723 10.7567 33.0846 10.0495 31.2277 10.0528C27.3777 9.83888 23.9555 13.0472 23.9555 16.8972V28.0194C20.3194 25.8805 18.1805 21.8167 17.9666 17.5389ZM61.3861 51.3333C61.6 56.8944 59.675 62.2417 56.0389 66.5194C55.6111 66.9472 55.1833 67.375 55.1833 68.0167V72.5083H30.3722V69.5139C30.3722 68.8722 29.9444 68.2305 29.5166 67.8028C28.0194 66.5194 26.7361 65.0222 25.6666 63.0972C24.3833 60.9583 23.5277 58.3917 23.1 55.825C23.1 55.3972 22.8861 54.9694 22.6722 54.5417L12.4055 42.35C11.7639 41.7083 11.3361 40.8528 11.3361 39.7833C11.3361 38.9278 11.7639 37.8583 12.4055 37.2167C13.9027 35.9333 16.0416 35.9333 17.5389 37.2167L23.7416 43.4194V49.8361L27.8055 47.6972V16.8972C28.0194 15.4 29.3027 14.1167 31.0139 14.3305C32.5111 14.3305 34.0083 15.4 34.0083 16.8972V41.4944L38.2861 42.35V32.5111C38.5 32.2972 38.7139 32.2972 38.9277 32.0833C40.425 32.0833 41.9222 32.2972 43.4194 32.5111V43.4194L46.8416 44.0611V32.9389L49.4083 33.5805C50.4777 33.7944 51.5472 34.2222 52.6166 34.65V45.3444L56.0389 45.9861V36.1472C57.9639 37.0028 59.675 38.2861 61.1722 39.7833L61.3861 51.3333Z"
          fill="#FF5349"
        />
      </g>
      <defs>
        <clipPath id="clip0_36_2">
          <rect width="77" height="77" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CartValueIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="77"
      height="77"
      viewBox="0 0 77 77"
      fill="none"
    >
      <path
        d="M43.3125 67.375V62.5625C46.4724 62.5625 49.6014 61.9401 52.5208 60.7309C55.4402 59.5216 58.0928 57.7492 60.3273 55.5148C62.5617 53.2803 64.3341 50.6277 65.5434 47.7083C66.7526 44.7889 67.375 41.6599 67.375 38.5H72.1875C72.1875 46.1581 69.1453 53.5026 63.7302 58.9177C58.3151 64.3328 50.9706 67.375 43.3125 67.375Z"
        fill="#FF5349"
      />
      <path
        d="M43.3125 55.3438V50.5312C44.8925 50.5312 46.457 50.2201 47.9167 49.6154C49.3764 49.0108 50.7027 48.1246 51.8199 47.0074C52.9371 45.8902 53.8233 44.5639 54.4279 43.1042C55.0326 41.6445 55.3438 40.08 55.3438 38.5H60.1562C60.1562 42.9672 58.3816 47.2515 55.2228 50.4103C52.064 53.5691 47.7797 55.3438 43.3125 55.3438Z"
        fill="#FF5349"
      />
      <path
        d="M64.9688 26.4688H50.5313V16.8438C50.5313 14.9292 49.7707 13.0931 48.417 11.7393C47.0632 10.3855 45.2271 9.625 43.3125 9.625H28.875C26.9605 9.625 25.1244 10.3855 23.7706 11.7393C22.4168 13.0931 21.6563 14.9292 21.6563 16.8438V26.4688H7.21878C6.86998 26.4648 6.5245 26.5367 6.20626 26.6796C5.88802 26.8224 5.60465 27.0327 5.37576 27.2959C5.14687 27.5591 4.97795 27.869 4.8807 28.204C4.78344 28.5389 4.76018 28.8911 4.81253 29.2359L9.33628 58.4719C9.5103 59.6194 10.0932 60.6654 10.9776 61.4171C11.8619 62.1688 12.9882 62.5756 14.1488 62.5625H36.0938V57.75H14.1007L10.0341 31.2812H64.9688V26.4688ZM26.4688 16.8438C26.4688 16.2056 26.7223 15.5935 27.1736 15.1423C27.6248 14.691 28.2368 14.4375 28.875 14.4375H43.3125C43.9507 14.4375 44.5627 14.691 45.014 15.1423C45.4653 15.5935 45.7188 16.2056 45.7188 16.8438V26.4688H26.4688V16.8438Z"
        fill="#FF5349"
      />
    </svg>
  );
};

export const ConversionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
    >
      <path
        d="M18.2292 8.75C16.4888 8.75 14.8196 9.4414 13.5889 10.6721C12.3582 11.9028 11.6667 13.572 11.6667 15.3125V22.6042C11.6667 23.466 11.8365 24.3193 12.1663 25.1155C12.4961 25.9117 12.9795 26.6352 13.5889 27.2446C14.8196 28.4753 16.4888 29.1667 18.2292 29.1667H45.9376C46.7994 29.1667 47.6527 28.9969 48.4489 28.6671C49.2451 28.3373 49.9686 27.8539 50.578 27.2446C51.1874 26.6352 51.6707 25.9117 52.0005 25.1155C52.3303 24.3193 52.5001 23.466 52.5001 22.6042V15.3125C52.5001 13.572 51.8087 11.9028 50.578 10.6721C49.3473 9.4414 47.6781 8.75 45.9376 8.75H18.2292ZM16.0417 15.3125C16.0417 14.7323 16.2722 14.1759 16.6825 13.7657C17.0927 13.3555 17.6491 13.125 18.2292 13.125H45.9376C46.5177 13.125 47.0741 13.3555 47.4844 13.7657C47.8946 14.1759 48.1251 14.7323 48.1251 15.3125V22.6042C48.1251 23.1843 47.8946 23.7407 47.4844 24.151C47.0741 24.5612 46.5177 24.7917 45.9376 24.7917H18.2292C17.6491 24.7917 17.0927 24.5612 16.6825 24.151C16.2722 23.7407 16.0417 23.1843 16.0417 22.6042V15.3125ZM25.3751 46.6667C24.2463 46.6667 23.3334 47.6467 23.3334 48.8542C23.3334 50.0617 24.2463 51.0417 25.3751 51.0417H38.7917C39.9205 51.0417 40.8334 50.0617 40.8334 48.8542C40.8334 47.6467 39.9205 46.6667 38.7917 46.6667H25.3751ZM50.613 47.9646L50.4001 48.2096C50.0297 48.5801 49.5387 48.8053 49.0163 48.8444C48.4939 48.8834 47.9748 48.7337 47.5534 48.4225L47.3084 48.2096L41.4751 42.3763C41.1046 42.0059 40.8794 41.5148 40.8403 40.9924C40.8012 40.47 40.9509 39.951 41.2622 39.5296L41.4751 39.2846L47.3084 33.4513C47.6992 33.0635 48.2219 32.8373 48.7722 32.8179C49.3224 32.7986 49.8597 32.9874 50.2769 33.3467C50.694 33.7061 50.9603 34.2095 51.0226 34.7565C51.0849 35.3036 50.9386 35.854 50.613 36.2979L50.4001 36.5429L48.303 38.6458H52.678C53.5801 38.6455 54.45 38.3108 55.1196 37.7064C55.7893 37.1019 56.211 36.2707 56.3034 35.3733L56.3238 35V28.4375C56.324 27.8833 56.5345 27.3498 56.9129 26.9448C57.2913 26.5398 57.8093 26.2935 58.3622 26.2558C58.9152 26.218 59.4619 26.3915 59.8918 26.7413C60.3217 27.091 60.6029 27.5909 60.6784 28.14L60.6988 28.4375V35C60.6989 37.043 59.9194 39.009 58.5193 40.4968C57.1193 41.9847 55.2043 42.8822 53.1651 43.0063L52.678 43.0208H48.3059L50.4001 45.1179C50.7706 45.4883 50.9958 45.9793 51.0349 46.5017C51.0739 47.0241 50.9243 47.5432 50.613 47.9646ZM52.5001 56.1458V50.2367L52.4622 50.2717C51.2809 51.4558 49.6622 51.9342 48.1251 51.7154V56.1458C48.1251 56.726 47.8946 57.2824 47.4844 57.6926C47.0741 58.1029 46.5177 58.3333 45.9376 58.3333H18.2292C17.6491 58.3333 17.0927 58.1029 16.6825 57.6926C16.2722 57.2824 16.0417 56.726 16.0417 56.1458V41.5625C16.0417 40.9823 16.2722 40.4259 16.6825 40.0157C17.0927 39.6055 17.6491 39.375 18.2292 39.375H38.1297C38.293 38.815 38.5584 38.2783 38.9172 37.7913L38.9842 37.7038L39.3342 37.2954L41.6326 35H18.2292C16.4888 35 14.8196 35.6914 13.5889 36.9221C12.3582 38.1528 11.6667 39.822 11.6667 41.5625V56.1458C11.6667 57.8863 12.3582 59.5555 13.5889 60.7862C14.8196 62.0169 16.4888 62.7083 18.2292 62.7083H45.9376C47.6781 62.7083 49.3473 62.0169 50.578 60.7862C51.8087 59.5555 52.5001 57.8863 52.5001 56.1458Z"
        fill="#FF5349"
      />
    </svg>
  );
};

export const GatewayIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
    >
      <path
        d="M56.6563 45.7187L64.3126 38.0625C64.7274 37.6675 65.0577 37.1924 65.2834 36.666C65.509 36.1396 65.6254 35.5728 65.6254 35C65.6254 34.4272 65.509 33.8604 65.2834 33.334C65.0577 32.8075 64.7274 32.3324 64.3126 31.9375L52.7188 20.3437L55.7813 17.2812C56.1173 17.4578 56.4971 17.5338 56.8751 17.5C57.7404 17.5 58.5862 17.2434 59.3057 16.7627C60.0252 16.2819 60.5859 15.5987 60.9171 14.7992C61.2482 13.9998 61.3348 13.1201 61.166 12.2715C60.9972 11.4228 60.5805 10.6433 59.9687 10.0314C59.3568 9.41955 58.5773 9.00287 57.7286 8.83406C56.8799 8.66525 56.0003 8.75189 55.2008 9.08302C54.4014 9.41415 53.7181 9.97491 53.2374 10.6944C52.7567 11.4138 52.5001 12.2597 52.5001 13.125C52.4663 13.503 52.5422 13.8828 52.7188 14.2187L39.3751 27.5625C38.0766 26.7063 36.5554 26.2498 35.0001 26.2498C33.4447 26.2498 31.9235 26.7063 30.6251 27.5625L23.4063 20.3437L35.0001 8.74999L42.6563 16.4062L45.7188 13.3437L38.0626 5.68749C37.6676 5.27265 37.1925 4.94238 36.6661 4.71671C36.1397 4.49103 35.5729 4.37466 35.0001 4.37466C34.4273 4.37466 33.8605 4.49103 33.3341 4.71671C32.8076 4.94238 32.3325 5.27265 31.9376 5.68749L20.3438 17.2812L17.2813 14.2187C17.4579 13.8828 17.5339 13.503 17.5001 13.125C17.5001 12.2597 17.2435 11.4138 16.7628 10.6944C16.282 9.97491 15.5988 9.41415 14.7993 9.08302C13.9999 8.75189 13.1202 8.66525 12.2716 8.83406C11.4229 9.00287 10.6433 9.41955 10.0315 10.0314C9.41964 10.6433 9.00296 11.4228 8.83415 12.2715C8.66534 13.1201 8.75198 13.9998 9.08311 14.7992C9.41424 15.5987 9.975 16.2819 10.6945 16.7627C11.4139 17.2434 12.2598 17.5 13.1251 17.5C13.5031 17.5338 13.8829 17.4578 14.2188 17.2812L27.5626 30.625C26.7063 31.9235 26.2499 33.4446 26.2499 35C26.2499 36.5554 26.7063 38.0765 27.5626 39.375L20.3438 46.5937L8.75008 35L16.4063 27.3437L13.3438 24.2812L5.68758 31.9375C5.27275 32.3324 4.94247 32.8075 4.7168 33.334C4.49112 33.8604 4.37476 34.4272 4.37476 35C4.37476 35.5728 4.49112 36.1396 4.7168 36.666C4.94247 37.1924 5.27275 37.6675 5.68758 38.0625L17.2813 49.6562L14.2188 52.7187C13.8829 52.5422 13.5031 52.4662 13.1251 52.5C12.2598 52.5 11.4139 52.7566 10.6945 53.2373C9.975 53.718 9.41424 54.4013 9.08311 55.2008C8.75198 56.0002 8.66534 56.8798 8.83415 57.7285C9.00296 58.5772 9.41964 59.3567 10.0315 59.9686C10.6433 60.5804 11.4229 60.9971 12.2716 61.1659C13.1202 61.3347 13.9999 61.2481 14.7993 60.917C15.5988 60.5858 16.282 60.0251 16.7628 59.3056C17.2435 58.5862 17.5001 57.7403 17.5001 56.875C17.5339 56.497 17.4579 56.1172 17.2813 55.7812L30.6251 42.4375C31.9235 43.2937 33.4447 43.7501 35.0001 43.7501C36.5554 43.7501 38.0766 43.2937 39.3751 42.4375L46.5938 49.6562L35.0001 61.25L27.3438 53.5937L24.2813 56.6562L31.9376 64.3125C32.3325 64.7273 32.8076 65.0576 33.3341 65.2833C33.8605 65.509 34.4273 65.6253 35.0001 65.6253C35.5729 65.6253 36.1397 65.509 36.6661 65.2833C37.1925 65.0576 37.6676 64.7273 38.0626 64.3125L49.6563 52.7187L52.7188 55.7812C52.7188 56.2187 52.5001 56.4375 52.5001 56.875C52.5001 57.7403 52.7567 58.5862 53.2374 59.3056C53.7181 60.0251 54.4014 60.5858 55.2008 60.917C56.0003 61.2481 56.8799 61.3347 57.7286 61.1659C58.5773 60.9971 59.3568 60.5804 59.9687 59.9686C60.5805 59.3567 60.9972 58.5772 61.166 57.7285C61.3348 56.8798 61.2482 56.0002 60.9171 55.2008C60.5859 54.4013 60.0252 53.718 59.3057 53.2373C58.5862 52.7566 57.7404 52.5 56.8751 52.5C56.4971 52.4662 56.1173 52.5422 55.7813 52.7187L42.4376 39.375C43.2938 38.0765 43.7502 36.5554 43.7502 35C43.7502 33.4446 43.2938 31.9235 42.4376 30.625L49.6563 23.4062L61.2501 35L53.5938 42.6562L56.6563 45.7187ZM35.0001 39.375C34.1348 39.375 33.2889 39.1184 32.5695 38.6377C31.85 38.1569 31.2892 37.4737 30.9581 36.6742C30.627 35.8748 30.5403 34.9951 30.7091 34.1465C30.878 33.2978 31.2946 32.5183 31.9065 31.9064C32.5183 31.2945 33.2979 30.8779 34.1466 30.7091C34.9952 30.5402 35.8749 30.6269 36.6743 30.958C37.4738 31.2892 38.157 31.8499 38.6378 32.5694C39.1185 33.2888 39.3751 34.1347 39.3751 35C39.3716 36.1592 38.9096 37.27 38.0899 38.0898C37.2701 38.9095 36.1593 39.3715 35.0001 39.375Z"
        fill="#FF5349"
      />
    </svg>
  );
};

export const IgIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13.0281 2.00073C14.1535 2.00259 14.7238 2.00855 15.2166 2.02322L15.4107 2.02956C15.6349 2.03753 15.8561 2.04753 16.1228 2.06003C17.1869 2.1092 17.9128 2.27753 18.5503 2.52503C19.2094 2.7792 19.7661 3.12253 20.3219 3.67837C20.8769 4.2342 21.2203 4.79253 21.4753 5.45003C21.7219 6.0867 21.8903 6.81337 21.9403 7.87753C21.9522 8.1442 21.9618 8.3654 21.9697 8.58964L21.976 8.78373C21.9906 9.27647 21.9973 9.84686 21.9994 10.9723L22.0002 11.7179C22.0003 11.809 22.0003 11.903 22.0003 12L22.0002 12.2821L21.9996 13.0278C21.9977 14.1532 21.9918 14.7236 21.9771 15.2163L21.9707 15.4104C21.9628 15.6347 21.9528 15.8559 21.9403 16.1225C21.8911 17.1867 21.7219 17.9125 21.4753 18.55C21.2211 19.2092 20.8769 19.7659 20.3219 20.3217C19.7661 20.8767 19.2069 21.22 18.5503 21.475C17.9128 21.7217 17.1869 21.89 16.1228 21.94C15.8561 21.9519 15.6349 21.9616 15.4107 21.9694L15.2166 21.9757C14.7238 21.9904 14.1535 21.997 13.0281 21.9992L12.2824 22C12.1913 22 12.0973 22 12.0003 22H11.7182L10.9725 21.9993C9.8471 21.9975 9.27672 21.9915 8.78397 21.9768L8.58989 21.9705C8.36564 21.9625 8.14444 21.9525 7.87778 21.94C6.81361 21.8909 6.08861 21.7217 5.45028 21.475C4.79194 21.2209 4.23444 20.8767 3.67861 20.3217C3.12278 19.7659 2.78028 19.2067 2.52528 18.55C2.27778 17.9125 2.11028 17.1867 2.06028 16.1225C2.0484 15.8559 2.03871 15.6347 2.03086 15.4104L2.02457 15.2163C2.00994 14.7236 2.00327 14.1532 2.00111 13.0278L2.00098 10.9723C2.00284 9.84686 2.00879 9.27647 2.02346 8.78373L2.02981 8.58964C2.03778 8.3654 2.04778 8.1442 2.06028 7.87753C2.10944 6.81253 2.27778 6.08753 2.52528 5.45003C2.77944 4.7917 3.12278 4.2342 3.67861 3.67837C4.23444 3.12253 4.79278 2.78003 5.45028 2.52503C6.08778 2.27753 6.81278 2.11003 7.87778 2.06003C8.14444 2.04816 8.36564 2.03847 8.58989 2.03062L8.78397 2.02433C9.27672 2.00969 9.8471 2.00302 10.9725 2.00086L13.0281 2.00073ZM12.0003 7.00003C9.23738 7.00003 7.00028 9.23956 7.00028 12C7.00028 14.7629 9.23981 17 12.0003 17C14.7632 17 17.0003 14.7605 17.0003 12C17.0003 9.23713 14.7607 7.00003 12.0003 7.00003ZM12.0003 9.00003C13.6572 9.00003 15.0003 10.3427 15.0003 12C15.0003 13.6569 13.6576 15 12.0003 15C10.3434 15 9.00028 13.6574 9.00028 12C9.00028 10.3431 10.3429 9.00003 12.0003 9.00003ZM17.2503 5.50003C16.561 5.50003 16.0003 6.05994 16.0003 6.74918C16.0003 7.43843 16.5602 7.9992 17.2503 7.9992C17.9395 7.9992 18.5003 7.4393 18.5003 6.74918C18.5003 6.05994 17.9386 5.49917 17.2503 5.50003Z"
        fill="#0F0F10"
      />
    </svg>
  );
};

export const XIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18.2048 2.25H21.5128L14.2858 10.51L22.7878 21.75H16.1308L10.9168 14.933L4.95084 21.75H1.64084L9.37084 12.915L1.21484 2.25H8.04084L12.7538 8.481L18.2048 2.25ZM17.0438 19.77H18.8768L7.04484 4.126H5.07784L17.0438 19.77Z"
        fill="#0F0F10"
      />
    </svg>
  );
};

export const FbIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14 13.5H16.5L17.5 9.5H14V7.5C14 6.47062 14 5.5 16 5.5H17.5V2.1401C17.1743 2.09685 15.943 2 14.6429 2C11.9284 2 10 3.65686 10 6.69971V9.5H7V13.5H10V22H14V13.5Z"
        fill="#0F0F10"
      />
    </svg>
  );
};

export const TwitterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="26"
      viewBox="0 0 24 26"
      fill="none"
    >
      <path
        d="M12 0C5.3736 0 0 5.8214 0 13C0 20.1786 5.3736 26 12 26C18.6264 26 24 20.1786 24 13C24 5.8214 18.6264 0 12 0ZM17.4791 10.136C17.4844 10.264 17.4869 10.3925 17.4869 10.5216C17.4869 14.4645 14.7166 19.0112 9.65021 19.0114H9.65039H9.65021C8.09473 19.0114 6.64728 18.5175 5.42834 17.6711C5.64386 17.6987 5.86322 17.7123 6.08533 17.7123C7.37585 17.7123 8.56348 17.2355 9.50629 16.4351C8.30054 16.4109 7.28394 15.5482 6.93311 14.3626C7.10101 14.3975 7.27368 14.4165 7.45074 14.4165C7.70215 14.4165 7.94568 14.3798 8.17712 14.3114C6.91681 14.038 5.96741 12.8314 5.96741 11.3865C5.96741 11.373 5.96741 11.3609 5.96777 11.3484C6.33893 11.572 6.76337 11.7065 7.21527 11.7215C6.47571 11.187 5.98956 10.2731 5.98956 9.23782C5.98956 8.69113 6.12598 8.17896 6.36255 7.73799C7.72083 9.5435 9.75073 10.7309 12.0399 10.8557C11.9927 10.6371 11.9683 10.4094 11.9683 10.1753C11.9683 8.52808 13.2019 7.1917 14.723 7.1917C15.5153 7.1917 16.2308 7.5545 16.7335 8.13452C17.361 8.00043 17.9502 7.75208 18.4825 7.41029C18.2765 8.10675 17.84 8.69113 17.2712 9.06068C17.8284 8.98848 18.3594 8.8284 18.8529 8.59076C18.4843 9.18922 18.0168 9.71489 17.4791 10.136Z"
        fill="#454242"
      />
    </svg>
  );
};

export const GiftIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.85547 4.21867H8.14453V7.49992H12.9492C13.1202 7.49992 13.2841 7.43201 13.405 7.31114C13.5258 7.19026 13.5938 7.02633 13.5938 6.85538V4.8632C13.5938 4.69226 13.5258 4.52832 13.405 4.40744C13.2841 4.28657 13.1202 4.21867 12.9492 4.21867H11.1967C11.434 3.72988 11.4893 3.17249 11.3526 2.64661C11.2159 2.12074 10.8961 1.66083 10.4508 1.34951C10.0055 1.0382 9.46373 0.895859 8.92289 0.948072C8.38205 1.00029 7.87755 1.24363 7.5 1.63439C7.1218 1.24577 6.61773 1.00431 6.07787 0.953163C5.53802 0.902018 4.99757 1.04452 4.55312 1.3552C4.10867 1.66588 3.78919 2.1245 3.65177 2.64907C3.51436 3.17364 3.56797 3.72999 3.80303 4.21867H2.05078C1.87984 4.21867 1.7159 4.28657 1.59503 4.40744C1.47416 4.52832 1.40625 4.69226 1.40625 4.8632V6.85538C1.40625 7.02633 1.47416 7.19026 1.59503 7.31114C1.65488 7.37099 1.72593 7.41846 1.80413 7.45085C1.88233 7.48324 1.96614 7.49992 2.05078 7.49992H6.85547V4.21867ZM8.14453 3.22257C8.14453 3.02556 8.20295 2.83298 8.3124 2.66917C8.42186 2.50537 8.57742 2.37769 8.75944 2.3023C8.94145 2.22691 9.14173 2.20718 9.33495 2.24562C9.52818 2.28405 9.70566 2.37892 9.84497 2.51823C9.98428 2.65753 10.0791 2.83502 10.1176 3.02824C10.156 3.22147 10.1363 3.42175 10.0609 3.60376C9.9855 3.78577 9.85783 3.94134 9.69403 4.05079C9.53022 4.16025 9.33763 4.21867 9.14062 4.21867H8.14453V3.22257ZM4.86328 3.22257C4.86328 2.95839 4.96823 2.70503 5.15503 2.51823C5.34183 2.33142 5.59519 2.22648 5.85938 2.22648C6.12356 2.22648 6.37692 2.33142 6.56372 2.51823C6.75052 2.70503 6.85547 2.95839 6.85547 3.22257V4.21867H5.85938C5.59519 4.21867 5.34183 4.11372 5.15503 3.92692C4.96823 3.74011 4.86328 3.48675 4.86328 3.22257ZM8.14453 14.0624H12.0117C12.1827 14.0624 12.3466 13.9945 12.4675 13.8736C12.5883 13.7528 12.6562 13.5888 12.6562 13.4179V8.43742H8.14453V14.0624ZM2.34375 13.4179C2.34375 13.5888 2.41166 13.7528 2.53253 13.8736C2.6534 13.9945 2.81734 14.0624 2.98828 14.0624H6.85547V8.43742H2.34375V13.4179Z"
        fill="white"
      />
    </svg>
  );
};

export const ProfileIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.0007 10.0003C12.3018 10.0003 14.1673 8.13485 14.1673 5.83366C14.1673 3.53247 12.3018 1.66699 10.0007 1.66699C7.69946 1.66699 5.83398 3.53247 5.83398 5.83366C5.83398 8.13485 7.69946 10.0003 10.0007 10.0003Z"
        stroke="#FF5349"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.1585 18.3333C17.1585 15.1083 13.9501 12.5 10.0001 12.5C6.05013 12.5 2.8418 15.1083 2.8418 18.3333"
        stroke="#FF5349"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const GlobeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="#0F0F10"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.99961 3H8.99961C7.04961 8.84 7.04961 15.16 8.99961 21H7.99961"
        stroke="#0F0F10"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15 3C16.95 8.84 16.95 15.16 15 21"
        stroke="#0F0F10"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 16V15C8.84 16.95 15.16 16.95 21 15V16"
        stroke="#0F0F10"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 8.99961C8.84 7.04961 15.16 7.04961 21 8.99961"
        stroke="#0F0F10"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CaretDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19.9201 8.9502L13.4001 15.4702C12.6301 16.2402 11.3701 16.2402 10.6001 15.4702L4.08008 8.9502"
        stroke="#058071"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const SecureIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        d="M21.3688 11.2873V6.8973C21.3688 6.0773 20.7488 5.1473 19.9788 4.8373L14.4088 2.5573C13.1588 2.0473 11.7488 2.0473 10.4988 2.5573L4.92883 4.8373C4.16883 5.1473 3.54883 6.0773 3.54883 6.8973V11.2873C3.54883 16.1773 7.09883 20.7573 11.9488 22.0973C12.2788 22.1873 12.6388 22.1873 12.9688 22.0973C17.8188 20.7573 21.3688 16.1773 21.3688 11.2873ZM13.2088 13.0373V15.6673C13.2088 16.0773 12.8688 16.4173 12.4588 16.4173C12.0488 16.4173 11.7088 16.0773 11.7088 15.6673V13.0373C10.6988 12.7173 9.95883 11.7773 9.95883 10.6673C9.95883 9.2873 11.0788 8.1673 12.4588 8.1673C13.8388 8.1673 14.9588 9.2873 14.9588 10.6673C14.9588 11.7873 14.2188 12.7173 13.2088 13.0373Z"
        fill="#00AA4F"
      />
    </svg>
  );
};

export const RemoveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z"
        fill="#C8170D"
      />
    </svg>
  );
};

export const BlackCaretDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19.9201 15.0496L13.4001 8.52965C12.6301 7.75965 11.3701 7.75965 10.6001 8.52965L4.08008 15.0496"
        stroke="#0F0F10"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const NQtyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.94645 14.6663C11.6131 14.6663 14.6131 11.6663 14.6131 7.99967C14.6131 4.33301 11.6131 1.33301 7.94645 1.33301C4.27979 1.33301 1.27979 4.33301 1.27979 7.99967C1.27979 11.6663 4.27979 14.6663 7.94645 14.6663Z"
        stroke="#ADAEB3"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.27979 8H10.6131"
        stroke="#ADAEB3"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const PQtyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8.00016 14.6663C11.6668 14.6663 14.6668 11.6663 14.6668 7.99967C14.6668 4.33301 11.6668 1.33301 8.00016 1.33301C4.3335 1.33301 1.3335 4.33301 1.3335 7.99967C1.3335 11.6663 4.3335 14.6663 8.00016 14.6663Z"
        stroke="#FF5349"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.3335 8H10.6668"
        stroke="#FF5349"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 10.6663V5.33301"
        stroke="#FF5349"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const LogoutIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8.90002 7.56023C9.21002 3.96023 11.06 2.49023 15.11 2.49023H15.24C19.71 2.49023 21.5 4.28023 21.5 8.75023V15.2702C21.5 19.7402 19.71 21.5302 15.24 21.5302H15.11C11.09 21.5302 9.24002 20.0802 8.91002 16.5402"
        stroke="#0F0F10"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15 12H3.62"
        stroke="#0F0F10"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.85 8.65039L2.5 12.0004L5.85 15.3504"
        stroke="#0F0F10"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const MenuIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3 7H21"
        stroke="#0F0F10"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M3 12H21"
        stroke="#0F0F10"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M3 17H21"
        stroke="#0F0F10"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const CartIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M2 2H3.74001C4.82001 2 5.67 2.93 5.58 4L4.75 13.96C4.61 15.59 5.89999 16.99 7.53999 16.99H18.19C19.63 16.99 20.89 15.81 21 14.38L21.54 6.88C21.66 5.22 20.4 3.87 18.73 3.87H5.82001"
        stroke="#4B0804"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.25 22C16.9404 22 17.5 21.4404 17.5 20.75C17.5 20.0596 16.9404 19.5 16.25 19.5C15.5596 19.5 15 20.0596 15 20.75C15 21.4404 15.5596 22 16.25 22Z"
        stroke="#4B0804"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.25 22C8.94036 22 9.5 21.4404 9.5 20.75C9.5 20.0596 8.94036 19.5 8.25 19.5C7.55964 19.5 7 20.0596 7 20.75C7 21.4404 7.55964 22 8.25 22Z"
        stroke="#4B0804"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 8H21"
        stroke="#4B0804"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const WWalletIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M2 8.50494H22"
        stroke="#003330"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 16.5049H8"
        stroke="#003330"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5 16.5049H14.5"
        stroke="#003330"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.44 3.50494H17.55C21.11 3.50494 22 4.38494 22 7.89494V16.1049C22 19.6149 21.11 20.4949 17.56 20.4949H6.44C2.89 20.5049 2 19.6249 2 16.1149V7.89494C2 4.38494 2.89 3.50494 6.44 3.50494Z"
        stroke="#003330"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const TravelIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9.02999 21.69L11.36 19.73C11.71 19.43 12.29 19.43 12.64 19.73L14.97 21.69C15.51 21.96 16.17 21.69 16.37 21.11L16.81 19.78C16.92 19.46 16.81 18.99 16.57 18.75L14.3 16.47C14.13 16.31 14 15.99 14 15.76V12.91C14 12.49 14.31 12.29 14.7 12.45L19.61 14.57C20.38 14.9 21.01 14.49 21.01 13.65V12.36C21.01 11.69 20.51 10.92 19.89 10.66L14.3 8.25001C14.14 8.18001 14 7.97001 14 7.79001V4.79001C14 3.85001 13.31 2.74001 12.47 2.31001C12.17 2.16001 11.82 2.16001 11.52 2.31001C10.68 2.74001 9.98999 3.86001 9.98999 4.80001V7.80001C9.98999 7.98001 9.84999 8.19001 9.68999 8.26001L4.10999 10.67C3.48999 10.92 2.98999 11.69 2.98999 12.36V13.65C2.98999 14.49 3.61999 14.9 4.38999 14.57L9.29999 12.45C9.67999 12.28 9.99999 12.49 9.99999 12.91V15.76C9.99999 15.99 9.86999 16.31 9.70999 16.47L7.43999 18.75C7.19999 18.99 7.08999 19.45 7.19999 19.78L7.63999 21.11C7.81999 21.69 8.47999 21.97 9.02999 21.69Z"
        stroke="#042D4D"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const PinterestIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13.3717 2.09442C8.42512 1.41268 3.73383 4.48505 2.38064 9.29256C1.02745 14.1001 3.42711 19.1692 8.00271 21.1689C7.94264 20.4008 7.99735 19.628 8.16502 18.8761C8.34964 18.0374 9.46121 13.4132 9.46121 13.4132C9.23971 12.9173 9.12893 12.379 9.13659 11.8359C9.13659 10.3509 9.99353 9.24295 11.0597 9.24295C11.4472 9.23718 11.8181 9.40028 12.0758 9.68981C12.3335 9.97934 12.4526 10.3667 12.402 10.751C12.402 11.6512 11.8236 13.0131 11.5228 14.2903C11.4014 14.7656 11.5131 15.2703 11.8237 15.65C12.1343 16.0296 12.6069 16.2389 13.0967 16.2139C14.9944 16.2139 16.2675 13.7825 16.2675 10.9126C16.2675 8.71205 14.8098 7.0655 12.1243 7.0655C10.826 7.01531 9.56388 7.4996 8.63223 8.40543C7.70057 9.31126 7.18084 10.5595 7.19423 11.859C7.16563 12.5722 7.39566 13.2717 7.84194 13.8287C8.01361 13.9564 8.07985 14.1825 8.00425 14.3827C7.9581 14.5673 7.84194 15.0059 7.79578 15.1675C7.77632 15.278 7.70559 15.3728 7.60516 15.4228C7.50473 15.4729 7.38651 15.4724 7.28654 15.4214C5.9019 14.8674 5.24957 13.3439 5.24957 11.6051C5.24957 8.75822 7.63424 5.3497 12.4036 5.3497C16.1998 5.3497 18.723 8.1273 18.723 11.0972C18.723 15.0059 16.5468 17.9451 13.3298 17.9451C12.3526 17.9761 11.4273 17.5061 10.8759 16.6986C10.8759 16.6986 10.2974 19.0146 10.1835 19.4531C9.95101 20.2099 9.60779 20.9281 9.16505 21.5844C10.0877 21.8643 11.0471 22.0044 12.0113 22C14.6636 22.0017 17.2078 20.9484 19.0829 19.072C20.958 17.1957 22.0099 14.6504 22.0069 11.9975C22.004 7.00306 18.3183 2.77616 13.3717 2.09442Z"
        fill="#0F0F10"
      />
    </svg>
  );
};

// export const XIcon = () => {
//   return (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width="20"
//       height="20"
//       viewBox="0 0 20 20"
//       fill="none">
//       <path
//         d="M6.66665 1.66663H0.833313L7.71736 10.8454L1.20827 18.3332H3.41663L8.74023 12.2091L13.3333 18.3333H19.1666L11.9931 8.76854L18.1667 1.66663H15.9584L10.9702 7.40478L6.66665 1.66663ZM14.1666 16.6666L4.16665 3.33329H5.83331L15.8333 16.6666H14.1666Z"
//         fill="#058071"
//       />
//     </svg>
//   );
// };

export const CloseCircleIcon = ({ size = 40 }: { size?: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M19.9997 36.6666C29.1663 36.6666 36.6663 29.1666 36.6663 19.9999C36.6663 10.8333 29.1663 3.33325 19.9997 3.33325C10.833 3.33325 3.33301 10.8333 3.33301 19.9999C3.33301 29.1666 10.833 36.6666 19.9997 36.6666Z"
        stroke="#0F0F10"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.2832 24.7168L24.7165 15.2834"
        stroke="#0F0F10"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.7165 24.7168L15.2832 15.2834"
        stroke="#0F0F10"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const GiftBagIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M13.3332 8.00065V12.0007C13.3332 13.474 12.1398 14.6673 10.6665 14.6673H5.33317C3.85984 14.6673 2.6665 13.474 2.6665 12.0007V8.00065C2.6665 7.63398 2.9665 7.33398 3.33317 7.33398H4.6465C5.01317 7.33398 5.31317 7.63398 5.31317 8.00065V10.094C5.31317 10.5873 5.5865 11.0407 6.01984 11.274C6.21317 11.3807 6.4265 11.434 6.6465 11.434C6.89984 11.434 7.15317 11.3607 7.37317 11.214L8.0065 10.8007L8.59317 11.194C8.99984 11.4673 9.51984 11.5007 9.95317 11.2673C10.3932 11.034 10.6665 10.5873 10.6665 10.0873V8.00065C10.6665 7.63398 10.9665 7.33398 11.3332 7.33398H12.6665C13.0332 7.33398 13.3332 7.63398 13.3332 8.00065Z"
        fill="#0F0F10"
      />
      <path
        d="M14.3332 4.66732V5.33398C14.3332 6.06732 13.9798 6.66732 12.9998 6.66732H2.99984C1.97984 6.66732 1.6665 6.06732 1.6665 5.33398V4.66732C1.6665 3.93398 1.97984 3.33398 2.99984 3.33398H12.9998C13.9798 3.33398 14.3332 3.93398 14.3332 4.66732Z"
        fill="#0F0F10"
      />
      <path
        d="M7.76018 3.33427H4.08018C3.85352 3.0876 3.86018 2.7076 4.10018 2.4676L5.04685 1.52094C5.29352 1.27427 5.70018 1.27427 5.94685 1.52094L7.76018 3.33427Z"
        fill="#0F0F10"
      />
      <path
        d="M11.9134 3.33427H8.2334L10.0467 1.52094C10.2934 1.27427 10.7001 1.27427 10.9467 1.52094L11.8934 2.4676C12.1334 2.7076 12.1401 3.0876 11.9134 3.33427Z"
        fill="#0F0F10"
      />
      <path
        d="M9.3133 7.33398C9.67996 7.33398 9.97996 7.63398 9.97996 8.00065V10.0873C9.97996 10.6207 9.38663 10.9407 8.94663 10.6407L8.34663 10.2407C8.12663 10.094 7.83996 10.094 7.61329 10.2407L6.98663 10.654C6.54663 10.9473 5.95996 10.6273 5.95996 10.1007V8.00065C5.95996 7.63398 6.25996 7.33398 6.62663 7.33398H9.3133Z"
        fill="#0F0F10"
      />
    </svg>
  );
};

export const BackIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9.57 5.92969L3.5 11.9997L9.57 18.0697"
        stroke="#0F0F10"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.4999 12H3.66992"
        stroke="#0F0F10"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const RemoveItemIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.99935 18.3327C14.5827 18.3327 18.3327 14.5827 18.3327 9.99935C18.3327 5.41602 14.5827 1.66602 9.99935 1.66602C5.41602 1.66602 1.66602 5.41602 1.66602 9.99935C1.66602 14.5827 5.41602 18.3327 9.99935 18.3327Z"
        stroke="#FF5349"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.64258 12.3592L12.3592 7.64258"
        stroke="#FF5349"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.3592 12.3592L7.64258 7.64258"
        stroke="#FF5349"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ChevronArrowDownIcon = ({
  color = "#0F0F10",
}: {
  color?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M13.2797 5.96667L8.93306 10.3133C8.41973 10.8267 7.57973 10.8267 7.06639 10.3133L2.71973 5.96667"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DarkNewGiftIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3337 8.00065V12.0007C13.3337 13.474 12.1403 14.6673 10.667 14.6673H5.33366C3.86033 14.6673 2.66699 13.474 2.66699 12.0007V8.00065C2.66699 7.63398 2.96699 7.33398 3.33366 7.33398H4.64699C5.01366 7.33398 5.31366 7.63398 5.31366 8.00065V10.094C5.31366 10.5873 5.58699 11.0407 6.02033 11.274C6.21366 11.3807 6.42699 11.434 6.64699 11.434C6.90033 11.434 7.15366 11.3607 7.37366 11.214L8.00699 10.8007L8.59366 11.194C9.00033 11.4673 9.52033 11.5007 9.95366 11.2673C10.3937 11.034 10.667 10.5873 10.667 10.0873V8.00065C10.667 7.63398 10.967 7.33398 11.3337 7.33398H12.667C13.0337 7.33398 13.3337 7.63398 13.3337 8.00065Z"
        fill="#0F0F10"
      />
      <path
        d="M14.3337 4.66732V5.33398C14.3337 6.06732 13.9803 6.66732 13.0003 6.66732H3.00033C1.98033 6.66732 1.66699 6.06732 1.66699 5.33398V4.66732C1.66699 3.93398 1.98033 3.33398 3.00033 3.33398H13.0003C13.9803 3.33398 14.3337 3.93398 14.3337 4.66732Z"
        fill="#0F0F10"
      />
      <path
        d="M7.76018 3.33427H4.08018C3.85352 3.0876 3.86018 2.7076 4.10018 2.4676L5.04685 1.52094C5.29352 1.27427 5.70018 1.27427 5.94685 1.52094L7.76018 3.33427Z"
        fill="#0F0F10"
      />
      <path
        d="M11.9134 3.33427H8.2334L10.0467 1.52094C10.2934 1.27427 10.7001 1.27427 10.9467 1.52094L11.8934 2.4676C12.1334 2.7076 12.1401 3.0876 11.9134 3.33427Z"
        fill="#0F0F10"
      />
      <path
        d="M9.3133 7.33398C9.67996 7.33398 9.97996 7.63398 9.97996 8.00065V10.0873C9.97996 10.6207 9.38663 10.9407 8.94663 10.6407L8.34663 10.2407C8.12663 10.094 7.83996 10.094 7.61329 10.2407L6.98663 10.654C6.54663 10.9473 5.95996 10.6273 5.95996 10.1007V8.00065C5.95996 7.63398 6.25996 7.33398 6.62663 7.33398H9.3133Z"
        fill="#0F0F10"
      />
    </svg>
  );
};

export const WalletLineIcon: React.FC<any> = ({
  width = 28,
  height = 24,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 24"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.00618 -0.000244141H26.0062C26.7426 -0.000244141 27.3395 0.596702 27.3395 1.33309V22.6664C27.3395 23.4028 26.7426 23.9998 26.0062 23.9998H2.00618C1.26981 23.9998 0.672852 23.4028 0.672852 22.6664V1.33309C0.672852 0.596702 1.26981 -0.000244141 2.00618 -0.000244141ZM24.6729 10.6664H3.33952V21.3331H24.6729V10.6664ZM24.6729 7.99976V2.66642H3.33952V7.99976H24.6729ZM16.6729 15.9998H22.0062V18.6664H16.6729V15.9998Z"
        fill="#C8170D"
      />
    </svg>
  );
};

export const HeartLineIcon: React.FC<any> = ({
  width = 33,
  height = 32,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 33 32"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.0648 4C26.1149 4 29.3981 7.33333 29.3981 12C29.3981 21.3333 19.3981 26.6667 16.0648 28.6667C12.7314 26.6667 2.73145 21.3333 2.73145 12C2.73145 7.33333 6.06478 4 10.0648 4C12.5447 4 14.7314 5.33333 16.0648 6.66667C17.3981 5.33333 19.5848 4 22.0648 4ZM17.31 24.8051C18.4854 24.0647 19.5448 23.3273 20.538 22.5372C24.5097 19.3773 26.7314 15.9247 26.7314 12C26.7314 8.85435 24.6821 6.66667 22.0648 6.66667C20.6302 6.66667 19.0772 7.42548 17.9504 8.55228L16.0648 10.4379L14.1792 8.55228C13.0524 7.42548 11.4993 6.66667 10.0648 6.66667C7.47686 6.66667 5.39811 8.87533 5.39811 12C5.39811 15.9247 7.6198 19.3773 11.5916 22.5372C12.5848 23.3273 13.6441 24.0647 14.8196 24.8051C15.2176 25.0559 15.6129 25.2972 16.0648 25.5669C16.5166 25.2972 16.912 25.0559 17.31 24.8051Z"
        fill="#058071"
      />
    </svg>
  );
};

export const MegaPhoneLineIcon: React.FC<any> = ({
  width = 33,
  height = 32,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 33 32"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9619 22.6667C12.9619 22.6667 22.2952 24 26.2952 28H27.6286C28.365 28 28.9619 27.4031 28.9619 26.6667V18.5827C30.112 18.2867 30.9619 17.2425 30.9619 16C30.9619 14.7575 30.112 13.7133 28.9619 13.4173V5.33333C28.9619 4.59696 28.365 4 27.6286 4H26.2952C22.2952 8 12.9619 9.33333 12.9619 9.33333H7.62858C6.15582 9.33333 4.96191 10.5272 4.96191 12V20C4.96191 21.4728 6.15582 22.6667 7.62858 22.6667H8.96191L10.2952 29.3333H12.9619V22.6667ZM15.6286 11.5483C16.5396 11.3528 17.6652 11.0826 18.881 10.725C21.1186 10.0669 23.9619 9.03016 26.2952 7.43277V24.5672C23.9619 22.9699 21.1186 21.9332 18.881 21.2751C17.6652 20.9175 16.5396 20.6472 15.6286 20.4517V11.5483ZM7.62858 12H12.9619V20H7.62858V12Z"
        fill="#049147"
      />
    </svg>
  );
};

export const ShoppingCartLineIcon: React.FC<any> = ({
  width = 33,
  height = 32,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 33 32"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.40397 21.3334V5.33335H2.7373V2.66669H6.7373C7.47369 2.66669 8.07064 3.26365 8.07064 4.00002V20H24.6552L27.3219 9.33335H10.7373V6.66669H29.0296C29.766 6.66669 30.3629 7.26365 30.3629 8.00002C30.3629 8.10903 30.3496 8.21765 30.3231 8.32341L26.9897 21.6567C26.8415 22.2503 26.3081 22.6667 25.6963 22.6667H6.7373C6.00093 22.6667 5.40397 22.0698 5.40397 21.3334ZM8.07064 30.6667C6.59788 30.6667 5.40397 29.4728 5.40397 28C5.40397 26.5272 6.59788 25.3334 8.07064 25.3334C9.5434 25.3334 10.7373 26.5272 10.7373 28C10.7373 29.4728 9.5434 30.6667 8.07064 30.6667ZM24.0707 30.6667C22.5979 30.6667 21.404 29.4728 21.404 28C21.404 26.5272 22.5979 25.3334 24.0707 25.3334C25.5435 25.3334 26.7373 26.5272 26.7373 28C26.7373 29.4728 25.5435 30.6667 24.0707 30.6667Z"
        fill="#0066AB"
      />
    </svg>
  );
};

export const ShieldCheckIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.7418 1.8583L4.58346 3.42497C3.62513 3.7833 2.8418 4.91663 2.8418 5.9333V12.125C2.8418 13.1083 3.4918 14.4 4.28346 14.9916L7.8668 17.6666C9.0418 18.55 10.9751 18.55 12.1501 17.6666L15.7335 14.9916C16.5251 14.4 17.1751 13.1083 17.1751 12.125V5.9333C17.1751 4.9083 16.3918 3.77497 15.4335 3.41663L11.2751 1.8583C10.5668 1.59997 9.43346 1.59997 8.7418 1.8583Z"
        stroke="#049147"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.5415 9.89157L8.88317 11.2332L12.4665 7.6499"
        stroke="#049147"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const LocationIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 8.95297C9.14875 8.95297 10.08 8.02172 10.08 6.87297C10.08 5.72422 9.14875 4.79297 8 4.79297C6.85125 4.79297 5.92 5.72422 5.92 6.87297C5.92 8.02172 6.85125 8.95297 8 8.95297Z"
        stroke="#84858C"
        stroke-width="1.5"
      />
      <path
        d="M2.41333 5.66065C3.72667 -0.112681 12.28 -0.106014 13.5867 5.66732C14.3533 9.05399 12.2467 11.9207 10.4 13.694C9.06 14.9873 6.94 14.9873 5.59333 13.694C3.75333 11.9207 1.64667 9.04732 2.41333 5.66065Z"
        stroke="#84858C"
        stroke-width="1.5"
      />
    </svg>
  );
};

// Reward Type Icon
export const CashbackRewardIcon = ({ className = "" }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3133 5.83335H11.3533C10.5067 5.83335 10 5.32669 10 4.48002V2.52002C10 1.67335 10.5067 1.16669 11.3533 1.16669H13.3133C14.16 1.16669 14.6667 1.67335 14.6667 2.52002V4.48002C14.6667 5.32669 14.16 5.83335 13.3133 5.83335ZM13.46 3.62669C13.38 3.54669 13.2733 3.50669 13.1667 3.50669C13.06 3.50669 12.9533 3.54669 12.8733 3.62669L12.7533 3.74669V2.25335C12.7533 2.02002 12.5667 1.83335 12.3333 1.83335C12.1 1.83335 11.9133 2.02002 11.9133 2.25335V3.74669L11.7933 3.62669C11.6333 3.46669 11.3667 3.46669 11.2067 3.62669C11.0467 3.78669 11.0467 4.05335 11.2067 4.21335L12.04 5.04669C12.0733 5.08002 12.12 5.10669 12.1667 5.12669C12.18 5.13335 12.1933 5.13335 12.2067 5.14002C12.24 5.15335 12.2733 5.16002 12.3133 5.16002C12.3267 5.16002 12.34 5.16002 12.3533 5.16002C12.4 5.16002 12.44 5.15335 12.4867 5.13335C12.4933 5.13335 12.4933 5.13335 12.5 5.13335C12.5467 5.11335 12.5867 5.08669 12.62 5.05335C12.6267 5.04669 12.6267 5.04669 12.6333 5.04669L13.4667 4.21335C13.6267 4.05335 13.6267 3.78669 13.46 3.62669Z"
        fill="#0F0F10"
      />
      <path
        d="M1.33333 7.63998V10.9733C1.33333 12.5 2.56666 13.7333 4.09333 13.7333H11.9C13.4267 13.7333 14.6667 12.4933 14.6667 10.9666V7.63998C14.6667 7.19331 14.3067 6.83331 13.86 6.83331H2.13999C1.69333 6.83331 1.33333 7.19331 1.33333 7.63998ZM5.33333 11.5H3.99999C3.72666 11.5 3.49999 11.2733 3.49999 11C3.49999 10.7266 3.72666 10.5 3.99999 10.5H5.33333C5.60666 10.5 5.83333 10.7266 5.83333 11C5.83333 11.2733 5.60666 11.5 5.33333 11.5ZM9.66666 11.5H7C6.72666 11.5 6.5 11.2733 6.5 11C6.5 10.7266 6.72666 10.5 7 10.5H9.66666C9.93999 10.5 10.1667 10.7266 10.1667 11C10.1667 11.2733 9.93999 11.5 9.66666 11.5Z"
        fill="#0F0F10"
      />
      <path
        d="M8.99999 3.07333V5.02666C8.99999 5.47333 8.63999 5.83333 8.19333 5.83333H2.13999C1.68666 5.83333 1.33333 5.46 1.33333 5.01333C1.33999 4.26 1.63999 3.57333 2.13999 3.07333C2.63999 2.57333 3.33333 2.26666 4.09333 2.26666H8.19333C8.63999 2.26666 8.99999 2.62666 8.99999 3.07333Z"
        fill="#0F0F10"
      />
    </svg>
  );
};

export const DiscountRewardIcon = ({ className = "" }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3333 7.99998V12C13.3333 13.4733 12.14 14.6666 10.6667 14.6666H5.33334C3.86001 14.6666 2.66667 13.4733 2.66667 12V7.99998C2.66667 7.63331 2.96667 7.33331 3.33334 7.33331H4.64667C5.01334 7.33331 5.31334 7.63331 5.31334 7.99998V10.0933C5.31334 10.5866 5.58667 11.04 6.02 11.2733C6.21334 11.38 6.42667 11.4333 6.64667 11.4333C6.9 11.4333 7.15334 11.36 7.37334 11.2133L8.00667 10.8L8.59334 11.1933C9 11.4666 9.52 11.5 9.95334 11.2666C10.3933 11.0333 10.6667 10.5866 10.6667 10.0866V7.99998C10.6667 7.63331 10.9667 7.33331 11.3333 7.33331H12.6667C13.0333 7.33331 13.3333 7.63331 13.3333 7.99998Z"
        fill="#0F0F10"
      />
      <path
        d="M14.3333 4.66665V5.33331C14.3333 6.06665 13.98 6.66665 13 6.66665H3.00001C1.98001 6.66665 1.66667 6.06665 1.66667 5.33331V4.66665C1.66667 3.93331 1.98001 3.33331 3.00001 3.33331H13C13.98 3.33331 14.3333 3.93331 14.3333 4.66665Z"
        fill="#0F0F10"
      />
      <path
        d="M7.76 3.33336H4.08C3.85333 3.08669 3.86 2.70669 4.1 2.46669L5.04667 1.52002C5.29333 1.27336 5.7 1.27336 5.94667 1.52002L7.76 3.33336Z"
        fill="#0F0F10"
      />
      <path
        d="M11.9133 3.33336H8.23334L10.0467 1.52002C10.2933 1.27336 10.7 1.27336 10.9467 1.52002L11.8933 2.46669C12.1333 2.70669 12.14 3.08669 11.9133 3.33336Z"
        fill="#0F0F10"
      />
      <path
        d="M9.31334 7.33331C9.68001 7.33331 9.98001 7.63331 9.98001 7.99998V10.0866C9.98001 10.62 9.38667 10.94 8.94667 10.64L8.34667 10.24C8.12667 10.0933 7.84001 10.0933 7.61334 10.24L6.98667 10.6533C6.54667 10.9466 5.96001 10.6266 5.96001 10.1V7.99998C5.96001 7.63331 6.26001 7.33331 6.62667 7.33331H9.31334Z"
        fill="#0F0F10"
      />
    </svg>
  );
};

export const PointRewardIcon = ({ className = "" }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6667 5.66665C14.6667 7.83998 13.0667 9.63331 10.9867 9.94665V9.90665C10.78 7.31998 8.68 5.21998 6.07333 5.01331H6.05333C6.36666 2.93331 8.16 1.33331 10.3333 1.33331C12.7267 1.33331 14.6667 3.27331 14.6667 5.66665Z"
        fill="#0F0F10"
      />
      <path
        d="M9.98666 9.98667C9.81999 7.87333 8.12666 6.18 6.01333 6.01333C5.9 6.00667 5.77999 6 5.66666 6C3.27333 6 1.33333 7.94 1.33333 10.3333C1.33333 12.7267 3.27333 14.6667 5.66666 14.6667C8.06 14.6667 10 12.7267 10 10.3333C10 10.22 9.99333 10.1 9.98666 9.98667ZM6.25333 10.92L5.66666 12L5.07999 10.92L3.99999 10.3333L5.07999 9.74667L5.66666 8.66667L6.25333 9.74667L7.33333 10.3333L6.25333 10.92Z"
        fill="#0F0F10"
      />
    </svg>
  );
};

export const FreeShippingRewardIcon = ({ className = "" }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3333 10.3333C14.52 10.3333 14.6667 10.48 14.6667 10.6666V11.3333C14.6667 12.44 13.7733 13.3333 12.6667 13.3333C12.6667 12.2333 11.7667 11.3333 10.6667 11.3333C9.56666 11.3333 8.66666 12.2333 8.66666 13.3333H7.33333C7.33333 12.2333 6.43333 11.3333 5.33333 11.3333C4.23333 11.3333 3.33333 12.2333 3.33333 13.3333C2.22666 13.3333 1.33333 12.44 1.33333 11.3333V9.99998C1.33333 9.63331 1.63333 9.33331 1.99999 9.33331H8.33333C9.25333 9.33331 10 8.58665 10 7.66665V3.99998C10 3.63331 10.3 3.33331 10.6667 3.33331H11.2267C11.7067 3.33331 12.1467 3.59331 12.3867 4.00665L12.8133 4.75331C12.8733 4.85998 12.7933 4.99998 12.6667 4.99998C11.7467 4.99998 11 5.74665 11 6.66665V8.66665C11 9.58665 11.7467 10.3333 12.6667 10.3333H14.3333Z"
        fill="#0F0F10"
      />
      <path
        d="M5.33333 14.6667C6.06971 14.6667 6.66667 14.0697 6.66667 13.3333C6.66667 12.597 6.06971 12 5.33333 12C4.59695 12 4 12.597 4 13.3333C4 14.0697 4.59695 14.6667 5.33333 14.6667Z"
        fill="#0F0F10"
      />
      <path
        d="M10.6667 14.6667C11.403 14.6667 12 14.0697 12 13.3333C12 12.597 11.403 12 10.6667 12C9.93028 12 9.33333 12.597 9.33333 13.3333C9.33333 14.0697 9.93028 14.6667 10.6667 14.6667Z"
        fill="#0F0F10"
      />
      <path
        d="M14.6667 8.35333V9.33333H12.6667C12.3 9.33333 12 9.03333 12 8.66667V6.66667C12 6.3 12.3 6 12.6667 6H13.5267L14.4933 7.69333C14.6067 7.89333 14.6667 8.12 14.6667 8.35333Z"
        fill="#0F0F10"
      />
      <path
        d="M8.72001 1.33331H3.79334C2.60001 1.33331 1.60001 2.18665 1.38001 3.31998H4.29334C4.54668 3.31998 4.74668 3.52665 4.74668 3.77998C4.74668 4.03331 4.54668 4.23331 4.29334 4.23331H1.33334V5.15331H3.06668C3.32001 5.15331 3.52668 5.35998 3.52668 5.61331C3.52668 5.86665 3.32001 6.06665 3.06668 6.06665H1.33334V6.98665H1.84668C2.10001 6.98665 2.30668 7.19331 2.30668 7.44665C2.30668 7.69998 2.10001 7.89998 1.84668 7.89998H1.33334V8.05331C1.33334 8.41998 1.63334 8.71998 2.00001 8.71998H8.10001C8.78001 8.71998 9.33334 8.16665 9.33334 7.48665V1.94665C9.33334 1.60665 9.06001 1.33331 8.72001 1.33331Z"
        fill="#0F0F10"
      />
      <path
        d="M1.38001 3.32001H1.28001H0.626672C0.373338 3.32001 0.166672 3.52667 0.166672 3.78001C0.166672 4.03334 0.373338 4.23334 0.626672 4.23334H1.23334H1.33334V3.79334C1.33334 3.63334 1.35334 3.47334 1.38001 3.32001Z"
        fill="#0F0F10"
      />
      <path
        d="M1.23334 5.15332H0.626672C0.373338 5.15332 0.166672 5.35999 0.166672 5.61332C0.166672 5.86665 0.373338 6.06665 0.626672 6.06665H1.23334H1.33334V5.15332H1.23334Z"
        fill="#0F0F10"
      />
      <path
        d="M1.23334 6.98663H0.626672C0.373338 6.98663 0.166672 7.1933 0.166672 7.44663C0.166672 7.69997 0.373338 7.89997 0.626672 7.89997H1.23334H1.33334V6.98663H1.23334Z"
        fill="#0F0F10"
      />
    </svg>
  );
};

export const StampsRewardIcon = ({ className = "" }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1 2.5733H6.60667V4.58664C6.60667 4.84664 6.39334 5.0533 6.14001 5.0533C5.88667 5.0533 5.67334 4.84664 5.67334 4.58664V2.5733H4.90001C2.26667 2.5733 1.40001 3.35997 1.34001 5.81997C1.33334 5.93997 1.38667 6.06664 1.47334 6.1533C1.56001 6.24664 1.67334 6.2933 1.80667 6.2933C2.74001 6.2933 3.50667 7.06664 3.50667 7.99997C3.50667 8.9333 2.74001 9.70664 1.80667 9.70664C1.68001 9.70664 1.56001 9.7533 1.47334 9.84664C1.38667 9.9333 1.33334 10.06 1.34001 10.18C1.40001 12.64 2.26667 13.4266 4.90001 13.4266H5.67334V11.4133C5.67334 11.1533 5.88667 10.9466 6.14001 10.9466C6.39334 10.9466 6.60667 11.1533 6.60667 11.4133V13.4266H11.1C13.8333 13.4266 14.6667 12.5933 14.6667 9.85997V6.13997C14.6667 3.40664 13.8333 2.5733 11.1 2.5733ZM12.3133 7.9333L11.6933 8.5333C11.6667 8.5533 11.66 8.5933 11.6667 8.62664L11.8133 9.4733C11.84 9.62664 11.78 9.78664 11.6467 9.87997C11.52 9.9733 11.3533 9.98664 11.2133 9.9133L10.4467 9.5133C10.42 9.49997 10.38 9.49997 10.3533 9.5133L9.58667 9.9133C9.52667 9.94664 9.46001 9.95997 9.39334 9.95997C9.30667 9.95997 9.22667 9.9333 9.15334 9.87997C9.02667 9.78664 8.96001 9.6333 8.98667 9.4733L9.13334 8.62664C9.14001 8.5933 9.12667 8.55997 9.10667 8.5333L8.48667 7.9333C8.37334 7.82664 8.33334 7.65997 8.38001 7.5133C8.42667 7.35997 8.55334 7.2533 8.71334 7.2333L9.56667 7.10664C9.60001 7.09997 9.62667 7.07997 9.64667 7.0533L10.0267 6.27997C10.1 6.13997 10.24 6.0533 10.4 6.0533C10.56 6.0533 10.7 6.13997 10.7667 6.27997L11.1467 7.0533C11.16 7.08664 11.1867 7.10664 11.22 7.10664L12.0733 7.2333C12.2333 7.2533 12.36 7.36664 12.4067 7.5133C12.4667 7.65997 12.4267 7.81997 12.3133 7.9333Z"
        fill="#0F0F10"
      />
    </svg>
  );
};

export const FreeItemRewardIcon = ({ className = "" }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8267 3.72H12.56L10.3067 1.46667C10.1267 1.28667 9.83333 1.28667 9.64666 1.46667C9.46666 1.64667 9.46666 1.94 9.64666 2.12667L11.24 3.72H4.75999L6.35333 2.12667C6.53333 1.94667 6.53333 1.65333 6.35333 1.46667C6.17333 1.28667 5.87999 1.28667 5.69333 1.46667L3.44666 3.72H3.17999C2.57999 3.72 1.33333 3.72 1.33333 5.42667C1.33333 6.07333 1.46666 6.5 1.74666 6.78C1.90666 6.94666 2.09999 7.03333 2.30666 7.08C2.49999 7.12666 2.70666 7.13333 2.90666 7.13333H13.0933C13.3 7.13333 13.4933 7.12 13.68 7.08C14.24 6.94666 14.6667 6.54667 14.6667 5.42667C14.6667 3.72 13.42 3.72 12.8267 3.72Z"
        fill="#0F0F10"
      />
      <path
        d="M12.7 8H3.24667C2.83334 8 2.52 8.36667 2.58667 8.77333L3.14667 12.2C3.33333 13.3467 3.83333 14.6667 6.05333 14.6667H9.79333C12.04 14.6667 12.44 13.54 12.68 12.28L13.3533 8.79333C13.4333 8.38 13.12 8 12.7 8ZM8 13C6.44 13 5.16667 11.7267 5.16667 10.1667C5.16667 9.89333 5.39334 9.66667 5.66667 9.66667C5.94 9.66667 6.16667 9.89333 6.16667 10.1667C6.16667 11.18 6.98667 12 8 12C9.01334 12 9.83334 11.18 9.83334 10.1667C9.83334 9.89333 10.06 9.66667 10.3333 9.66667C10.6067 9.66667 10.8333 9.89333 10.8333 10.1667C10.8333 11.7267 9.56 13 8 13Z"
        fill="#0F0F10"
      />
    </svg>
  );
};

export const StarIcon = ({ bg = "#4C4D52" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8.00007 12.1734L3.29777 14.8055L4.34799 9.51997L0.391602 5.86124L5.74296 5.22675L8.00007 0.333374L10.2571 5.22675L15.6085 5.86124L11.6521 9.51997L12.7023 14.8055L8.00007 12.1734Z"
        fill={bg}
      />
    </svg>
  );
};

export const FilterIcon = ({ color = "#0F0F10" }: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.49992 1.75H15.4999C16.4166 1.75 17.1666 2.5 17.1666 3.41667V5.25C17.1666 5.91667 16.7499 6.75 16.3333 7.16667L12.7499 10.3333C12.2499 10.75 11.9166 11.5833 11.9166 12.25V15.8333C11.9166 16.3333 11.5833 17 11.1666 17.25L9.99992 18C8.91659 18.6667 7.41658 17.9167 7.41658 16.5833V12.1667C7.41658 11.5833 7.08325 10.8333 6.74992 10.4167L3.58325 7.08333C3.16659 6.66667 2.83325 5.91667 2.83325 5.41667V3.5C2.83325 2.5 3.58325 1.75 4.49992 1.75Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.10833 1.75L5 8.33333"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SearchIcon = ({ width = "24", height = "24" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
        stroke="#4C4D52"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 22L20 20"
        stroke="#4C4D52"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AddIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 10H15"
        stroke="#0F0F10"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 15V5"
        stroke="#0F0F10"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};


export const ShoppingBagIcon = ({size = 16, color = "#84858C"}:{size?: number, color?: string}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.60002 4.3335H10.4C12.6667 4.3335 12.8934 5.3935 13.0467 6.68683L13.6467 11.6868C13.84 13.3268 13.3334 14.6668 11 14.6668H5.00668C2.66668 14.6668 2.16002 13.3268 2.36002 11.6868L2.96002 6.68683C3.10669 5.3935 3.33335 4.3335 5.60002 4.3335Z" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5.33325 5.3335V3.00016C5.33325 2.00016 5.99992 1.3335 6.99992 1.3335H8.99992C9.99992 1.3335 10.6666 2.00016 10.6666 3.00016V5.3335" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M13.6066 11.3535H5.33325" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
};
